import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const ADD_EMERGENCY_CONTACT = `${PRIVATE_ROOT}/apartment/emergency-contacts/add`
export const EDIT_EMERGENCY_CONTACT = `${PRIVATE_ROOT}/apartment/emergency-contacts/:id/edit`
export const EMERGENCY_CONTACTS = `${PRIVATE_ROOT}/apartment/emergency-contacts`
